import { initConfig } from '../config';
import { CoreNormalizer } from './core';
export function normalize(spec, config) {
  if (config === undefined) {
    config = initConfig(spec.config);
  }

  return normalizeGenericSpec(spec, config);
}
var normalizer = new CoreNormalizer();
/**
 * Decompose extended unit specs into composition of pure unit specs.
 */

function normalizeGenericSpec(spec) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return normalizer.map(spec, {
    config: config
  });
}